module.exports = __webpack_public_path__ + "media/images/swimmer-cb70b63f46d24ef4854367034d6b8e33.jpg";